import Input from "@/components/frontend/ui/form/inputs/input";
import { type FormTextBlock as FormTextBlockT } from "@/payload-types";

type FormTextBlockProps = FormTextBlockT & {
	containerClassName?: string;
	fieldName?: string;
	fieldValue?: unknown;
	fieldError?: string;
	onFieldChange?: (value: unknown) => void;
	onFieldBlur?: () => void;
};

export const FormTextBlock: React.FC<FormTextBlockProps> = ({
	content,
	settings,
	containerClassName,
	fieldName,
	fieldValue,
	fieldError,
	onFieldChange,
	onFieldBlur,
}) => {
	const minLength = typeof settings?.minLength === "number" ? settings.minLength : undefined;
	const maxLength = typeof settings?.maxLength === "number" ? settings.maxLength : undefined;

	return (
		<Input
			name={fieldName}
			value={typeof fieldValue === "string" ? fieldValue : ""}
			onChange={(event) => onFieldChange?.(event.target.value)}
			onBlur={onFieldBlur}
			autoComplete={settings?.autocomplete ?? undefined}
			placeholder={content.placeholder}
			label={content.label}
			hideLabel={settings?.hideLabel ?? undefined}
			description={content.description}
			minLength={minLength}
			maxLength={maxLength}
			error={fieldError}
			required={content.required ?? false}
			containerClassName={containerClassName}
		/>
	);
};
